export default "__VITE_ASSET__ChuvyYr3__"